import React from 'react';

import Google from '../../../iconComponents/special/Google';

import AuthenticationButton, { AuthenticationButtonProps } from '.';
import { useAuth } from '~/context/AuthContext';

interface GoogleAuthenticationButtonProps extends Omit<AuthenticationButtonProps, 'icon' | 'children'> {
  label?: string;
}

const GoogleAuthenticationButton: React.FC<GoogleAuthenticationButtonProps> = ({
  label = 'Sign in with Google',
  ...props
}) => {
  const { signInWithGoogle, isLoadingGoogle } = useAuth();

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch {
      // do nothing
    }
  };

  return (
    <AuthenticationButton
      icon={<Google className="h-20 w-20" />}
      onClick={handleGoogleSignIn}
      disabled={isLoadingGoogle}
      {...props}
    >
      {isLoadingGoogle ? 'Signing in...' : label}
    </AuthenticationButton>
  );
};

export default GoogleAuthenticationButton;
